import * as React from 'react';
import { Form, Input, Button, Select } from 'antd';
import config from 'src/config';

const { Option } = Select;
const API_URL = config.search.LOT_SEARCH_HOST;

export class LotSearch extends React.Component<any, any> {

  dpRef: any;
  lotNoRef: any;
  sectionNoRef: any;
  planTypeRef: any;

  constructor(props: any) {
    super(props);
    this.dpRef = React.createRef();
    this.lotNoRef = React.createRef();
    this.sectionNoRef = React.createRef();
    this.planTypeRef = React.createRef();
    // The lotsearch validation fields have been taken out and are not currently used but may be used in the future
    this.state = { lotSearchValidationStatus: '', lotSearchValidationMessage: '' };
  }

  getInfo = async () => {

    const lot = this.lotNoRef.current.input.value;
    const planType = this.planTypeRef.current.rcSelect.state.value[0];
    const section = this.sectionNoRef.current.input.value;
    const dp = this.dpRef.current.input.value;

    const request = { lot, section, planType, dp };

    const response = await fetch(API_URL, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    });

    const responseJson = await response.json();
    if (responseJson.errorMessage && responseJson.status && responseJson.status[0] == 1) {
      this.props.setQuery({
        query: {
          'query': {
            'simple_query_string': {
              'query': 'this is dummy query, expect no results come back',
              'fields': [
                'field 1 not exist',
                'field 2 not exist',
                'field 3 not exist'
              ],
              'default_operator': 'and'
            }
          }
        },
        value: []
      });
    } else {
      this.props.setQuery({
        query: responseJson,
        value: []
      });
    }
    this.props.onShowHideHomePage(['lotSearch']);
    this.props.showReloadButton();
  };

  render() {
    return (
      <div>
        <Form layout="inline">
          <Form.Item
            hasFeedback>
            <Input placeholder="LotNo" style={{ width: 200 }} ref={this.lotNoRef}/>
          </Form.Item>
          <Form.Item>
            <Input placeholder="SectionNo" style={{ width: 200 }} ref={this.sectionNoRef}/>
          </Form.Item>
          <Form.Item>
            <Input placeholder="PlanNo" style={{ width: 200 }} required={true} ref={this.dpRef}/>
          </Form.Item>
          <Form.Item>
            <Select defaultValue="DP" style={{ width: 200 }} ref={this.planTypeRef}>
              <Option value="DP">DP</Option>
              <Option value="SP">SP</Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" icon="search" onClick={this.getInfo}>Search</Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/search/LotSearch.tsx